import { render, staticRenderFns } from "./PreviousWorksSwiper.vue?vue&type=template&id=78ea74ed&"
import script from "./PreviousWorksSwiper.vue?vue&type=script&lang=js&"
export * from "./PreviousWorksSwiper.vue?vue&type=script&lang=js&"
import style0 from "./PreviousWorksSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports